import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useHistory } from "react-router-dom";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import {
  Typography,
  Toolbar,
  AppBar,
  IconButton,
  Link,
  Button,
  ClickAwayListener,
  Grow,
  Paper,
  Popper,
  MenuItem,
  MenuList,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowDropDownRoundedIcon from "@material-ui/icons/ArrowDropDownRounded";

// Contexts
import AuthContext from "../../context/auth/AuthContext";
import ParameterContext from "../../context/parameters/ParameterContext";

const Navbar = ({ openState, drawerWidth }) => {
  const useStyles = makeStyles((theme) => ({
    appBar: {
      backgroundColor: theme.palette.primary.dark,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    appBarShift: {
      backgroundColor: theme.palette.primary.dark,
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
      transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    hide: {
      display: "none",
    },
    title: {
      flexGrow: 1,
    },
    link: {
      textDecoration: "none",
      "&:hover": {
        textDecoration: "none",
      },
    },
    button: {
      textTransform: "none",
      "&:focus": {
        outline: "none",
      },
    },
    burger_button: {
      marginRight: theme.spacing(2),
    },
    menu_button: {
      color: "white",
    },
    menu_paper: {
      marginTop: "0.8rem",
      backgroundColor: theme.palette.primary.dark,
    },
    menu_item: {
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
    },
    menu_link: {
      color: "white",
      "&:hover": {
        color: "white",
      },
    },
  }));

  const classes = useStyles();
  const history = useHistory();

  const { isAuthenticated, user, logout, token } = useContext(AuthContext);
  const menu_list = [
    {
      name: "Change Password",
      link: "/change-password",
    },
    {
      name: "Logout",
      link: "/login",
    },
  ];

  const guest_menu_list = [
    {
      name: "Login",
      link: "/login",
    },
  ];

  const [navbar_list, setNavbarList] = useState([]);
  const [guest, setGuest] = useState();
  const [menu, setMenu] = useState(false);
  const [open, setOpen] = openState;

  const menuRef = useRef(null);
  const prevMenu = useRef(menu);

  const onClick = (e, link) => {
    if (link === "/login") {
      if (token) {
        setGuest();
        setMenu(false);
        setOpen(false);
        logout();
      } else {
        history.push(link);
      }
    } else {
      history.push(link);
      handleClose(e);
    }
  };

  const handleDrawerOpen = () => setOpen(true);

  const handleToggle = () => setMenu((prevMenu) => !prevMenu);

  const handleClose = (e) => {
    if (menuRef.current && menuRef.current.contains(e.target)) return;
    setMenu(false);
  };

  const handleListKeyDown = (e) => {
    if (e.key === "Tab") {
      e.preventDefault();
      setMenu(false);
    }
  };

  useEffect(() => {
    prevMenu.current = menu;
  }, [menu]);

  useEffect(() => {
    if (!token) {
      setGuest("guest");
    } else {
      setGuest("auth");
    }
  }, [token]);

  useEffect(() => {
    if (isAuthenticated && user) {
      setNavbarList(menu_list);
    } else {
      setNavbarList(guest_menu_list);
    }
  }, [isAuthenticated, user]);

  const authLinks = (
    <Button
      ref={menuRef}
      aria-controls={menu ? "menu-list-grow" : undefined}
      aria-haspopup="true"
      onClick={handleToggle}
      className={clsx(classes.button, classes.menu_button)}
    >
      Hi, {user && user.name} <ArrowDropDownRoundedIcon />
    </Button>
  );

  const guestLinks = (
    <Fragment>
      {navbar_list.map((each, index) => {
        return (
          <Link
            key={index}
            className={clsx(classes.link, classes.menu_link)}
            onClick={(e) => onClick(e, each.link)}
          >
            <i className={each.icon}> </i>&ensp;{each.name}
          </Link>
        );
      })}
    </Fragment>
  );

  return (
    <AppBar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: open,
      })}
      style={{
        zIndex: 10,
      }}
    >
      <Toolbar>
        
        {guest === "auth" && isAuthenticated && user && (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(
              classes.burger_button,
              classes.button,
              open && classes.hide
            )}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography variant="h6" noWrap className={classes.title}>
          {open ? null : (
            <Link
              onClick={(e) => onClick(e, "/")}
              className={clsx(classes.link, classes.menu_link)}
            >
              Conqore
            </Link>
          )}
        </Typography>

        <Typography variant="body1" noWrap className={classes.button}>
          
          {guest === "guest"
            ? guestLinks
            : isAuthenticated && user && authLinks}
        </Typography>

        {guest === "auth" && isAuthenticated && user && (
          <Popper
            open={menu}
            anchorEl={menuRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper className={classes.menu_paper}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={menu}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      {navbar_list.map((each, index) => {
                        return (
                          <MenuItem key={index} className={classes.menu_item}>
                            <Link
                              className={clsx(classes.link, classes.menu_link)}
                              style={{ color: "white" }}
                              onClick={(e) => onClick(e, each.link)}
                            >
                              <i className={each.icon}> </i>&ensp;{each.name}
                            </Link>
                          </MenuItem>
                        );
                      })}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
